import { CommonStore } from '../common-store';

const storeModule = new CommonStore(
  'camp/knowledge/video',
  { name: 'camp.knowledge.video.index' }
);

export default {
  namespaced: storeModule.namespaced,
  state: storeModule.state,
  getters: storeModule.getters,
  actions: storeModule.actions,
  mutations: storeModule.mutations
};
